<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M2.666 12.292c0-.574.296-1.108.783-1.413l11.667-7.292a1.667 1.667 0 011.767 0l11.666 7.292c.488.305.784.839.784 1.413v14.743c0 .92-.746 1.667-1.667 1.667H4.333c-.92 0-1.667-.746-1.667-1.667V12.292zm13.333-6.898l11.293 7.058L16 19.51 4.706 12.452 16 5.394z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsMailOpenFilled'
}
</script>
